import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';
import { GrayButton, SecondaryButton, Spinner } from 'components';
import * as styles from './PartnerAdjustmentFields.scss';
var PartnerAdjustmentFields = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PartnerAdjustmentFields, _Component);

  var _super = _createSuper(PartnerAdjustmentFields);

  function PartnerAdjustmentFields() {
    var _this;

    _classCallCheck(this, PartnerAdjustmentFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var val = e.target.value;
      var fieldName = e.target.id;

      _this.props.handleFormFieldChange(fieldName, val);
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (fieldName, value, hintText, floatingLabelText, width) {
      floatingLabelText = typeof floatingLabelText === 'undefined' ? hintText : floatingLabelText;
      width = typeof width === 'undefined' ? '100%' : width;
      return /*#__PURE__*/React.createElement(TextField, {
        hintText: hintText,
        floatingLabelText: floatingLabelText,
        id: fieldName,
        value: value,
        onChange: _this.handleChange,
        style: {
          width: width
        }
      });
    });

    return _this;
  }

  _createClass(PartnerAdjustmentFields, [{
    key: "render",
    value: function render() {
      var formValues = this.props.formValues;
      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginBottom: 40
        }
      }, this.props.showClientField && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderInput('additionalClients', formValues.additionalClients, 'Additional Clients')), this.props.showTeamMemberField && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderInput('additionalTeamMembers', formValues.additionalTeamMembers, 'Additional Team Members'))));
    }
  }]);

  return PartnerAdjustmentFields;
}(Component), _defineProperty(_class2, "defaultProps", {
  showClientField: true,
  showTeamMemberField: true
}), _temp)) || _class);
export default PartnerAdjustmentFields;